module.exports = __webpack_public_path__ + "static/media/national.46308269.png";